import React from 'react';
import PropTypes from 'prop-types';
import EntityApplicationContainer from '../../containers/EntityApplicationContainer';
import FormstackEntityApplicationContainer from '../../containers/FormstackEntityApplicationContainer';
import EntityProgressBar from '../EntityProgressBar';
import hasFormstackHandoff from '../../lib/formstack/hasFormstackHandoff';

export { hasFormstackHandoff };

export const EntityApplicationPage = ({ showEmbeddedExperience }) => {
  return (
    <section className="form-content-section-primary flow-text">
      <EntityProgressBar />
      <div className="container">
        <div className="row">
          <div id="applicationPage" className="col col-md-12 col-lg-12">
            <h1 id="page-header" className="h1_secondary text-center">
              Application
            </h1>
            {showEmbeddedExperience
              ? <FormstackEntityApplicationContainer />
              : <EntityApplicationContainer />}
          </div>
        </div>
      </div>
    </section>
  );
};

EntityApplicationPage.propTypes = {
  showEmbeddedExperience: PropTypes.bool,
};

EntityApplicationPage.defaultProps = {
  showEmbeddedExperience: false,
};

export default EntityApplicationPage;
